export function obterConfiguracaoBase(): any {
  return {
    actions: {
      columnTitle: "Ações",
      position: "right",
    },
    noDataMessage: "Não possui dado",
    pager: {
      display: false,
    },
    attr: {
      class: "table table-striped table-bordered",
    },
  };
}

export function obterConfiguracaoAdd(solicitaConfirmacao: Boolean = false) {
  return {
    addButtonContent:
      '<i class="btn btn-sm btn-padrao"><span class="fas fa-plus"></span></i>',
    createButtonContent:
      '<i class="btn btn-xs icon-btn btn-padrao"><span class="fas fa-check"></span></i>',
    cancelButtonContent:
      '<i class="btn btn-xs icon-btn btn-danger"><span class="fas fa-times"></span></i>',
    confirmSave: solicitaConfirmacao,
  };
}

export function ObterConfiguracaoEditar(solicitaConfirmacao: Boolean = false) {
  return {
    editButtonContent:
      '<i class="btn btn-xs icon-btn btn-warning"><span class="fas fa-edit font-size-12pt"></span></i>',
    saveButtonContent:
      '<i class="btn btn-xs icon-btn btn-padrao"><span class="fas fa-check"></span></i>',
    cancelButtonContent:
      '<i class="btn btn-xs icon-btn btn-danger"><span class="fas fa-times"></span></i>',
    confirmSave: solicitaConfirmacao,
  };
}

export function obterConfiguracaoDeletar(solicitaConfirmacao: Boolean = true) {
  return {
    deleteButtonContent:
      '<i class="btn btn-xs icon-btn btn-danger"><span class="far fa-trash-alt"></span></i>',
    confirmDelete: solicitaConfirmacao,
  };
}
